import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { TreasuryContext } from "../../../context/TreasuryContextProvider";
import * as API from "../../../utils/services/api";

const TreasuryAllocation = () => {
  const { totalTreasury } = useContext(TreasuryContext);
  const [liquidityPool, setLiquidityPool] = useState(null);
  const [condodata, setCondoData] = useState(null);
  const [allTreasuryData, setAllTreasuryData] = useState([]);
  const [loadingTreasury, setLoadingTreasury] = useState(true);
  const [allTreasuryTokenData, setAllTreasuryTokenData] = useState([]);

  const url =
    "https://condo-app-server-2ef9df89c3da.herokuapp.com/api/condo/liquidityPool";

  const condoUrl =
    "https://condo-app-server-2ef9df89c3da.herokuapp.com/api/condo";

  useEffect(() => {
    const fetchliquidityPool = async () => {
      try {
        const resp = await axios.get(url);
        setLiquidityPool(resp.data.liquidityPool);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchliquidityPool();
  }, []);
  useEffect(() => {
    const fetchCondoData = async () => {
      try {
        const resp = await axios.get(condoUrl);
        setCondoData(resp.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCondoData();
  }, []);
  useEffect(() => {
    const fetchTreasuryData = async () => {
      try {
        setLoadingTreasury(true);
        const resp = await API.getAllTreasuryToken();
        setAllTreasuryData(resp.data?.totalBalance);
        setAllTreasuryTokenData(resp.data?.treasuryTokens);
      } catch (error) {
        console.error("Error fetching treasury data:", error);
      } finally {
        setLoadingTreasury(false);
      }
    };

    fetchTreasuryData();

    const intervalId = setInterval(fetchTreasuryData, 30000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div className="container poetsen-one-regular treasury-bg">
      <h4 className="mb-4 mt-3"> Quick Overview</h4>
      <div className="row">
        <div className="col-lg-3 col-6">
          <div className="real-time-div">
            <div className="real-time-data-p-left">
              <h4 style={{ color: "rgb(184, 0, 0)" }}>Total Treasury </h4>
              <div className="dots-tokenomics"></div>
              <div className="dots-tokenomics-2"></div>
              <div className="dots-tokenomics-3"></div>
              <div className="dots-tokenomics-4"></div>
            </div>
            <div className="real-time-data-p-right">
              <p> ${allTreasuryData && allTreasuryData.toLocaleString()}</p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="real-time-div">
            <div className="real-time-data-p-left">
              <h4 style={{ color: "rgb(184, 0, 0)" }}>Locked Liquidity </h4>
              {/* <p>Updating Soon...</p> */}
              <div className="dots-tokenomics"></div>
              <div className="dots-tokenomics-2"></div>
              <div className="dots-tokenomics-3"></div>
              <div className="dots-tokenomics-4"></div>
            </div>
            <div className="real-time-data-p-right">
              ${liquidityPool ? Number(liquidityPool).toLocaleString() : "-"}
              {/* <p>0%</p>{" "} */}
              {/* <p>$147,000</p> */}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="real-time-div">
            <div className="real-time-data-p-left">
              <h4 style={{ color: "rgb(184, 0, 0)" }}>Market Cap</h4>
              {/* <p>Updating Soon...</p> */}
              <div className="dots-tokenomics"></div>
              <div className="dots-tokenomics-2"></div>
              <div className="dots-tokenomics-3"></div>
              <div className="dots-tokenomics-4"></div>
            </div>
            <div className="real-time-data-p-right">
              {/* <p>0%</p>{" "} */}$
              {condodata?.condoDetail?.market_cap.toLocaleString()}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-6">
          <div className="real-time-div">
            <div className="real-time-data-p-left">
              <h4 style={{ color: "rgb(184, 0, 0)" }}>Total Supply</h4>
              {/* <p>Coming Soon...</p> */}
              <div className="dots-tokenomics"></div>
              <div className="dots-tokenomics-2"></div>
              <div className="dots-tokenomics-3"></div>
              <div className="dots-tokenomics-4"></div>
            </div>
            <div className="real-time-data-p-right">
              ${condodata?.condoDetail?.total_supply.toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreasuryAllocation;
